import React, { Component } from 'react';
import { inject, observer } from 'mobx-react';
import { Modal } from 'react-bootstrap';
import moment from 'moment';
import WorkPatternPreview from './WorkPatternAssignment/WorkPatternPreview';
import CloseModalIcon from '../../../assets/img/CloseApproveModalIcon.svg';
import withLocalization from '../../../hoc/withLocalization';

class WorkPatternHistoryModal extends Component {
    constructor(props) {
        super(props);
        this.state = {
            history: null,
            isLoading: false,
            expandedVersion: null,
        };
    }

    componentDidUpdate(prevProps) {
        if (this.props.show && !prevProps.show) {
            this.loadHistory();
        }
        if (!this.props.show && prevProps.show) {
            this.setState({ history: null, expandedVersion: null, isLoading: false });
        }
    }

    loadHistory = async () => {
        const { templateId, rosterStore, commonStore, t } = this.props;
        if (!templateId) return;
        this.setState({ isLoading: true });
        try {
            const res = await rosterStore.getWorkPatternHistory({ template_id: templateId });
            const expandedVersion = res?.versions?.length > 0 ? res.versions[0].version : null;
            this.setState({ history: res, expandedVersion });
        } catch (err) {
            commonStore.addNotification(err?.message || t('Something went wrong'), null, 'error');
        } finally {
            this.setState({ isLoading: false });
        }
    };

    toggleVersion = (version) => {
        this.setState(prev => ({ expandedVersion: prev.expandedVersion === version ? null : version }));
    };

    formatDate = (date) => moment(date).format('DD.MM.YYYY');

    getVersionLabel = (v, t) => {
        const from = v.apply_from ? this.formatDate(v.apply_from) : null;
        const to = v.apply_to ? this.formatDate(v.apply_to) : null;
        if (!from && !to) return `v${v.version}`;
        if (!from) return `v${v.version} — ${t('Until')} ${to}`;
        if (!to) return `v${v.version} — ${from} → ${t('Present')}`;
        return `v${v.version} — ${from} → ${to}`;
    };

    render() {
        const { show, handleClose, t, commonStore } = this.props;
        const { history, isLoading, expandedVersion } = this.state;

        const companyShiftMap = new Map(
            (commonStore.sortCompanyShifts(commonStore?.config?.companyShifts || [])).map(s => [s.id, s])
        );

        return (
            <Modal show={show} onHide={handleClose} size="lg" centered>
                <Modal.Header>
                    <Modal.Title className="fs14 fw-700">
                        {t('Work Pattern')} {t('History')}
                        {history?.template_name && (
                            <span>— {history.template_name}</span>
                        )}
                    </Modal.Title>
                    <img src={CloseModalIcon} className="cursor-pointer" alt="close" onClick={handleClose} />
                </Modal.Header>

                <Modal.Body style={{ maxHeight: 'calc(100vh - 140px)', overflowY: 'auto' }}>
                    {isLoading && (
                        <div className="d-flex justify-content-center align-items-center" style={{ height: '200px' }}>
                            <div className="spinner-border text-primary" />
                        </div>
                    )}

                    {!isLoading && !history?.versions?.length && (
                        <p className="text-muted text-center fs14 mt-4">{t('No data found')}</p>
                    )}

                    {!isLoading && history?.versions?.map((v) => {
                        const isCurrent = !v.apply_to;
                        const isExpanded = expandedVersion === v.version;
                        const versionLabel = this.getVersionLabel(v, t);

                        return (
                            <div
                                key={v.version}
                                className="mb-3 border rounded"
                                style={{ borderLeft: `4px solid ${isCurrent ? '#2550AC' : '#adb5bd'}` }}
                            >
                                <div
                                    className="d-flex justify-content-between align-items-center p-3 cursor-pointer"
                                    style={{ backgroundColor: isExpanded ? '#f0f4ff' : '#fff', borderRadius: '4px' }}
                                    onClick={() => this.toggleVersion(v.version)}
                                >
                                    <div className="d-flex align-items-center gap-2">
                                        {isCurrent && (
                                            <span className="badge text-white" style={{ fontSize: '10px', backgroundColor: '#2550AC' }}>{t('Active')}</span>
                                        )}
                                        <span className="fw-600 fs13">{versionLabel}</span>
                                    </div>
                                    <i className={`fa fa-chevron-${isExpanded ? 'up' : 'down'} text-muted`} style={{ fontSize: '12px' }} />
                                </div>

                                {isExpanded && (
                                    <div className="border-top">
                                        <WorkPatternPreview
                                            t={t}
                                            companyShiftMap={companyShiftMap}
                                            workPatternDetails={{
                                                label: `${history.template_name} — v${v.version}`,
                                                automation: history.automation,
                                                weeks: v.weeks,
                                                total_weeks: v.weeks.length,
                                            }}
                                        />
                                    </div>
                                )}
                            </div>
                        );
                    })}
                </Modal.Body>
            </Modal>
        );
    }
}

export default inject('rosterStore', 'commonStore')(withLocalization(observer(WorkPatternHistoryModal)));
